<div>
  <i
    *ngIf="productOpen"
    (click)="toggleProduct()"
    class="material-icons right"
    style="color: #415853"
  >
    keyboard_arrow_up
  </i>
  <i
    *ngIf="!productOpen"
    (click)="toggleProduct()"
    class="material-icons right"
    style="color: #415853"
  >
    keyboard_arrow_down
  </i>
</div>
<div class="row rfq-list-view">
  <div class="">
    <div class="number float-left">{{ product.itemNumber }}</div>
  </div>
  <div class="col-md-3 left-window pr-0">
    <div class="vs-text-field">
      <label class="prod_top heading-label">
        {{ "quoteTracking.partNumberDesc" | cxTranslate }}
      </label>
      <div class="bold">
        {{ product.partNumber }}
      </div>
      <div class="bold product-data-text">{{ product.partDescription }}</div>
    </div>

    <div *ngIf="productOpen" class="vs-text-field">
      <label class="prod_top heading-label mt-12">{{ "quoteTracking.serialNumber" | cxTranslate }}</label>
      <div *ngIf="product.serialNumber" class="bold product-data-text">
        {{ product.serialNumber }}
      </div>
      <div *ngIf="!product.serialNumber" class="bold product-data-text">
        <br />
      </div>

      <label
        class="prod_top heading-label mt-52 label-tag"
        style="margin-top: 45px"
        >{{ "quoteTracking.tagNo" | cxTranslate }}</label
      >
      <div class="bold product-data-text">{{ product.tagNumber }}</div>

      <label
        *ngIf="
          product.orderNumber &&
          product.orderNumber !== '' &&
          product.orderNumber !== null
        "
        class="prod_top heading-label mt-52 label-tag"
        style="margin-top: 45px"
        >{{ "quoteTracking.orderNo" | cxTranslate }}</label
      >
      <div class="bold product-data-text order-number">
        {{ product.orderNumber }}
      </div>
    </div>
  </div>

  <div class="col-md-2">
    <div class="vs-text-field">
      <label class="heading-label"> {{ "quoteTracking.quant" | cxTranslate }} </label>
      <div class="bold">{{ product.quantity }} {{ product.salesUnit }}</div>
    </div>

    <div *ngIf="productOpen" class="vs-text-field">
      <label class="prod_top heading-label">{{ "quoteTracking.unitPrice" | cxTranslate }}</label>
      <div class="bold product-data-text">
        {{ currency }}
        {{ product.quoteNetPrice | currency: currency:"symbol-narrow" }}
      </div>
      <a
        *ngIf="
          product?.discountValues?.length || product?.priceAdderData?.length
        "
        (click)="this.breakUp = !this.breakUp"
        class="arw view-price-details"
        >{{ "quoteTracking.viewDetail" | cxTranslate }}<i *ngIf="!breakUp" class="material-icons"
          >keyboard_arrow_down</i
        >
        <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i></a
      >

      <!-- <div class="price-menu"
          *ngIf="breakUp"
          (clickOutside)="closeMenu($event)" [exclude]="'a,.arw'"
        >
          <div class="row space">
            <div class="col-6 bold">List Price</div>
            <div
              class="col-6 float-right bold"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice | currency:currency:'symbol': '1.2-2'}}"
            >
            {{currency}} {{ product.quoteNetPrice | currency: currency:'symbol': '1.2-2'}}            
            </div>
          </div>
          <div class="row space">
            <div class="col-6"> Region Discount</div>
            <div
              class="col-6 float-right"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice -
                (product.quoteNetPrice * 0.2) | currency:currency:'symbol':'1.2-2'
              }}"
            >
            {{currency}} {{ product.quoteNetPrice -
              (product.quoteNetPrice * 0.2) | currency:currency:'symbol':'1.2-2'
            }}"
            </div>
            <div class="col-6">Customer Discount</div>
            <div
              class="col-6 float-right"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice -
                ((product.quoteNetPrice - product.quoteNetPrice * 0.2) * 0.1 )
                  | currency: currency :'symbol':'1.2-2'
              }} "
            >
            {{currency}} {{ product.quoteNetPrice -
              ((product.quoteNetPrice - product.quoteNetPrice * 0.2) * 0.1 )
                | currency: currency :'symbol':'1.2-2'
            }} "
            </div>
          </div>
          <div class="row space">
            <div class="col-6">Product Discount</div>
            <div
              class="col-6 float-right"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice -
                ((product.quoteNetPrice - product.quoteNetPrice * 0.2) * 0.1 )
                  | currency: currency :'symbol':'1.2-2'
              }} "
            >
            {{currency}} {{ product.quoteNetPrice -
              ((product.quoteNetPrice - product.quoteNetPrice * 0.2) * 0.1 )
                | currency: currency :'symbol':'1.2-2'
            }} 
            </div>
          </div>
          <div class="row space">
            <div class="col-6">Manual Discount</div>
            <div
              class="col-6 float-right"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice -
                ((product.quoteNetPrice - product.quoteNetPrice * 0.2) * 0.1 )
                  | currency: currency: 'symbol':'1.2-2'
              }} "
            >
            {{currency}} {{ product.quoteNetPrice -
              ((product.quoteNetPrice - product.quoteNetPrice * 0.2) * 0.1 )
                | currency: currency: 'symbol':'1.2-2'
            }} 
            </div>
          </div>
          <hr class="horizontal-divider"/>
          <div class="row space">
            <div class="col-6">Total Adjustment</div>
            <div
              class="col-6 float-right"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice -
                (product.quoteNetPrice * 0.2 + product.quoteNetPrice * 0.1) 
                  | currency: currency:'symbol':'1.2-2'
              }}"
            >{{currency}} {{ product.quoteNetPrice -
              (product.quoteNetPrice * 0.2 + product.quoteNetPrice * 0.1) 
                | currency: currency:'symbol':'1.2-2'
            }}
            </div>
          </div>
          <hr class="horizontal-divider"/>  
          <div class="row space">
            <div class="col-6 bold">Net Price</div>
            <div
              class="col-6 float-right bold"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              matTooltip="{{currency}} {{ product.quoteNetPrice | currency: currency: 'symbol': '1.2-2'}}"
            >
            {{currency}} {{ product.quoteNetPrice | currency: currency: 'symbol': '1.2-2'}}            
            </div>
          </div>
        </div> -->
      <div
        class="breakup-dropdown"
        *ngIf="breakUp"
        (clickOutside)="closeMenu($event)"
        [exclude]="'a,.arw'"
      >
        <div class="row list-price-row m-0">
          <span class="price-menu-heading bold col-6">{{ "quoteTracking.listPrice" | cxTranslate }}</span>
          <span class="price-menu-content bold col-6"
            >{{ currency }}
            {{
              product?.listPrice | currency: currency:"symbol-narrow"
            }}</span
          >
        </div>
        <div
          class="row discounts"
          *ngFor="let discounts of product?.discountValues"
        >
          <span class="price-menu-heading col-6">{{
            getDiscountName(discounts.code)
          }}</span>
          <span class="price-menu-content col-2"
            >{{ discounts.appliedValue | number: "1.0-1" }}%</span
          >
          <span class="price-menu-content col-4"
            >{{ discounts.currency }} -{{ discounts.formattedValue }}</span
          >
        </div>
        <div
          class="row discounts"
          *ngFor="let discounts of product?.priceAdderData"
        >
          <span class="price-menu-heading col-6">{{
            getDiscountName(discounts.code)
          }}</span>
          <span class="price-menu-content col-2"
            >{{ discounts.appliedValue | number: "1.0-0" }}%</span
          >
          <span class="price-menu-content col-4"
            >{{ discounts.currency }} {{ discounts.formattedValue }}</span
          >
        </div>
        <div
          class="row total-discounts"
          *ngIf="
            product?.discountValues?.length > 0 ||
            product?.priceAdderData?.length > 0
          "
        >
          <span class="price-menu-heading col-6">{{ "quoteTracking.totalAdjustment" | cxTranslate }}</span>
          <span class="price-menu-content col-6"
            >{{ currency }}
            {{
              getTotalDiscounts(
                product?.discountValues,
                product?.priceAdderData
              )  
            }}</span
          >
        </div>
        <div class="row net-price">
          <span class="price-menu-heading bold col-6">{{ "quoteTracking.netPrice" | cxTranslate }}</span>
          <span class="price-menu-content bold col-6"
            >{{ currency }}
            {{
              product?.quoteNetPrice | currency: currency:"symbol-narrow"
            }}</span
          >
        </div>
      </div>

      <label class="prod_top heading-label">{{ "quoteTracking.extendedPrice" | cxTranslate }}</label>
      <div class="bold product-data-text">
        {{ currency }}
        {{ product.quoteExtendedPrice | currency: currency:"symbol-narrow" }}
      </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="vs-text-field">
      <label class="heading-label">{{ "quoteTracking.reqShipDate" | cxTranslate }}</label>
      <div class="bold product-data-text">
        {{ product.requestedShipDate | date: "dd MMM yyyy" }}
      </div>
    </div>
    <div *ngIf="productOpen" class="fieldCsrAlign">
      <label class="prod_top heading-label">{{ "quoteTracking.csr" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.fieldCsr }}</div>

      <label class="prod_top heading-label mt-44">{{ "quoteTracking.addComments" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.additionalComments }}</div>
    </div>
  </div>

  <div class="col-md-2">
    <div class="vs-text-field">
      <div class="heading-label">
        {{ "quoteTracking.deliveryTime" | cxTranslate }}
        <i
          class="material-icons info"
          matTooltipClass="vs-tooltip"
          matTooltip='{{ "quoteTracking.deliveryTimeToolTip" | cxTranslate }} {{ product.quoteLeadTime }}'
          >info</i
        >
      </div>
      <div class="bold product-data-text">
        {{ product.quoteLeadTime }}
      </div>
    </div>
  </div>

  <div class="col-md-1">
    <div class="item-status">
      <div>{{ "quoteTracking.status" | cxTranslate }}</div>
      <div>
        <span class="status-label" [ngClass]="product.quoteStatusCode">{{
          product.quoteStatusLabel
        }}</span>
      </div>
    </div>
    <div
      class="rfrjctn"
      *ngIf="productOpen && product.quoteStatusLabel === 'Closed - Rejected'"
    >
      <label class="prod_top heading-label">{{ "quoteTracking.rejection" | cxTranslate }}</label>
      <div class="bold product-data-text-reason">
        {{ product.reasonForRejection }}
      </div>
    </div>
  </div>
</div>
